<div class="dialog">
  @if (isMobileView()) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="close()" [ngStyle]="{ cursor: 'pointer' }" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">{{ 'Event' | translate }} {{ (eventId ? 'Edit' : 'Add') | translate | lowercase }}</h2>
      <p [ngStyle]="{ cursor: 'pointer' }" class="disabled" disabled="true" translate>Save</p>
    </header>
  }

  @if (!isMobileView()) {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'Event' | translate }} {{ (eventId ? 'Edit' : 'Add') | translate | lowercase }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px', cursor: 'pointer' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    <form [formGroup]="form" action="" class="form">
      <div class="align-fields">
        <div>
          <!-- Image Selector -->
          <div class="input-group">
            <label for="image" translate>Image</label>
            <app-image-selector
              (imageSelected)="selectedImage = $event"
              [aspectRatio]="4 / 3"
              [entityId]="eventId"
              [fullWidthPreview]="true"
              [imageCropper]="true"
              [isUpdateMode]="isUpdateMode"
              [sectionType]="SectionType.EVENT"
              formControlName="image"
              id="image"
              name="image"
            ></app-image-selector>
            <!--            <app-form-error [control]="form.get('image')" [name]="'Image' | translate"></app-form-error>-->
          </div>

          <!-- Event Name -->
          <div class="input-group --required">
            <label for="eventName" translate>Name of the Event</label>
            <input [placeholder]="'Name' | translate" class="full-width-input" formControlName="name" id="eventName" maxlength="150" name="eventName" type="text" />
            <app-form-error [control]="form.get('name')" [name]="'Event Name' | translate"></app-form-error>
          </div>

          <!-- Venue -->
          <div class="input-group --required">
            <label for="venue" translate>Venue</label>
            <ng-select
              [addTagText]="'Add Venue' | translate"
              [addTag]="addTagFn"
              [closeOnSelect]="true"
              [items]="eventVenues"
              [multiple]="false"
              [notFoundText]="'No venue available' | translate"
              [placeholder]="'Venue' | translate"
              [searchable]="true"
              [selectOnTab]="true"
              bindLabel="name"
              bindValue="value"
              class="custom"
              formControlName="place"
              id="venue"
              name="venue"
            ></ng-select>
            <app-form-error [control]="form.get('place')" [name]="'Venue' | translate"></app-form-error>
          </div>

          <!-- Event Types -->
          <div class="input-group --required">
            <label for="eventType" translate>Event Types</label>
            <app-dropdown [disabled]="shouldLockGroupDropdown" [options]="eventTypes" bindValue="value" displayName="key" formControlName="type" id="eventType" name="eventType"></app-dropdown>
            <app-form-error [control]="form.get('type')" [name]="'Event Type' | translate"></app-form-error>
          </div>

          <!-- Tags -->
          <div class="input-group">
            <label for="tags" translate>Tags</label>
            <ng-select
              [addTagText]="'Add Tag' | translate"
              [addTag]="addTagFn"
              [closeOnSelect]="true"
              [items]="tags"
              [multiple]="true"
              [notFoundText]="'No tags available' | translate"
              [placeholder]="'Select Tags' | translate"
              [searchable]="true"
              [selectOnTab]="true"
              bindLabel="label"
              bindValue="value"
              class="custom"
              formControlName="eventTagsArray"
              id="tags"
              name="tags"
            ></ng-select>
          </div>

          <!-- Description -->
          <div class="input-group --required">
            <label for="description" translate>Description</label>
            <textarea [placeholder]="'Enter Description' | translate" class="full-width-input" formControlName="description" id="description" name="description" rows="3"></textarea>
            <app-form-error [control]="form.get('description')" [name]="'Description' | translate"></app-form-error>
          </div>

          <!-- Choose File -->
          <div class="flex-row-start-center gap-10">
            @if (currentSelectedEvent?.document) {
              <button
                (click)="downloadDocument(currentSelectedEvent)"
                [disabled]="loadings.downloadingDocument"
                [tippy]="'Download File' | translate"
                class="button button-simple button-icon-only mt-8"
              >
                <app-icon iconName="download"></app-icon>
              </button>
              <button (click)="deleteFile(currentSelectedEvent)" [disabled]="loadings.deletingDocument" [tippy]="'Delete File' | translate" class="button button-simple button-icon-only mt-8">
                <app-icon iconName="trash"></app-icon>
              </button>
            }
            <div class="w-100">
              <app-file-selector-input (attachmentSelected)="selectedAttachment = $event" [accept]="'.pdf'"></app-file-selector-input>
            </div>
          </div>

          <!-- Weekdays -->
          <ng-container formArrayName="eventDate">
            <div class="input-group">
              <label translate>Event Date</label>
              <div class="input-groups-wrapper">
                @for (weekday of eventDateFormArray.controls; track weekday; let i = $index) {
                  <ng-container [formGroupName]="i">
                    <div class="flex-row-between-center gap-10">
                      <!-- Date From -->
                      <div class="input-group w-100 --required">
                        <label for="dateFrom-{{ i }}" translate>Start Date</label>
                        <app-date-picker-input [id]="'dateFrom' + i" [pastDatesSelection]="false" formControlName="dateFrom" name="dateFrom"></app-date-picker-input>
                        <app-form-error [control]="eventDateFormArray.controls[i].get('dateFrom')" [name]="'Start Date' | translate"></app-form-error>
                      </div>
                      <!-- Date To-->
                      <div class="input-group w-100 --required">
                        <label for="dateTo-{{ i }}" translate>End Date</label>
                        <app-date-picker-input
                          [id]="'dateTo' + i"
                          [pastDatesSelection]="false"
                          [preSelectedDate]="eventDateFormArray.controls[i].get('dateFrom').value"
                          formControlName="dateEnd"
                          name="dateTo"
                        ></app-date-picker-input>
                        <app-form-error [control]="eventDateFormArray.controls[i].get('dateEnd')" [name]="'End Date' | translate"></app-form-error>
                      </div>
                    </div>
                    <div class="flex-row-between-center gap-10">
                      <!--  Time From  -->
                      <div class="input-group w-100 --required">
                        <label for="startTime-{{ i }}" translate>Time From</label>
                        <app-time-picker-input [id]="'startTime-' + i" [name]="'startTime-' + i" class="full-width-input" formControlName="startTime"></app-time-picker-input>
                        <app-form-error [control]="eventDateFormArray.controls[i].get('startTime')" [name]="'Time From' | translate"></app-form-error>
                      </div>
                      <!-- Time TO -->
                      <div class="input-group w-100 --required">
                        <label class="endTime-{{ i }}" translate>Time To</label>
                        <app-time-picker-input
                          [id]="'endTime-' + i"
                          [name]="'endTime-' + i"
                          [previousSelectedTime]="eventDateFormArray.controls[i].get('startTime').value"
                          class="full-width-input"
                          formControlName="endTime"
                        ></app-time-picker-input>
                        <app-form-error [control]="eventDateFormArray.controls[i].get('endTime')" [name]="'Time To' | translate"></app-form-error>
                      </div>
                    </div>
                  </ng-container>
                  <div class="flex-row-end-center gap-6 mt-12">
                    @if (i === eventDateFormArray.controls.length - 1 && !allDaysSelected) {
                      <button (click)="addWeekdaysRow()" [tippy]="'Add' | translate" class="button button-simple button-icon-only">
                        <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="add" size="20px"></app-icon>
                      </button>
                    }
                    @if (eventDateFormArray.controls.length > 1) {
                      <button (click)="removeWeekdaysRow(i)" [tippy]="'Remove' | translate" class="button button-simple button-icon-only">
                        <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="trash-bin" size="20px"></app-icon>
                      </button>
                    }
                  </div>
                }
              </div>
            </div>
          </ng-container>

          <!--  Repeat Event  -->
          @if (isSingleValidDateFrom) {
            <div class="input-group --required">
              <label for="repeatEvent" translate>Repeat Event</label>
              <app-dropdown [options]="repeatEvent" bindValue="value" displayName="key" formControlName="repeatEvent" id="repeatEvent" name="repeatEvent"></app-dropdown>
              <app-form-error [control]="form.get('repeatEvent')" [name]="'Repeat Event' | translate"></app-form-error>
            </div>
          }

          <!-- Repeat Event End Date -->
          @if (showEndDate) {
            <div class="input-group --required">
              <label for="repeat-event-end-date" translate>End Date</label>
              <app-date-picker-input [pastDatesSelection]="false" formControlName="repeatEndDate" id="repeat-event-end-date" name="repeat-event-end-date"></app-date-picker-input>
              <app-form-error [control]="form.get('repeatEndDate')" [name]="'End Date' | translate"></app-form-error>
            </div>
          }

          <!-- Visibility of Event -->
          <div class="input-group --required">
            <label for="visibility" translate>Visibility of Event</label>
            <app-dropdown
              [disabled]="shouldLockGroupDropdown"
              [options]="visibilityOfEvent"
              bindValue="value"
              displayName="key"
              formControlName="visibility"
              id="visibility"
              name="visibility"
            ></app-dropdown>
            <app-form-error [control]="form.get('visibility')" [name]="'Visibility of Event' | translate"></app-form-error>
          </div>

          <!-- Users -->
          @if (form.get('visibility').value === EventVisibility.Private || form.get('visibility').value === EventVisibility.Public) {
            <div class="input-group">
              <label for="tags" translate>Invite Participants</label>
              <ng-select
                [closeOnSelect]="true"
                [items]="users"
                [multiple]="true"
                [placeholder]="'Select Options' | translate"
                [searchable]="true"
                bindLabel="fullName"
                bindValue="id"
                class="custom"
                dropdownPosition="top"
                formControlName="participants"
                id="users"
                name="users"
              >
                <!--              <ng-template ng-header-tmp>-->
                <!--                <button class="button button-small button-outline-primary" (click)="selectAllParticipants()" translate>Select all</button>-->
                <!--                <button class="button button-small button-simple" (click)="unSelectAll()" translate>Unselect all</button>-->
                <!--              </ng-template>-->
                <ng-template ng-footer-tmp>
                  <button (click)="selectAllParticipants()" class="button button-small button-outline-primary" translate>Select all</button>
                  <button (click)="unSelectAll()" class="button button-small button-simple" translate>Unselect all</button>
                </ng-template>
              </ng-select>
              <!--              <app-form-error [control]="form.get('participants')" [name]="'Participants' | translate"></app-form-error>-->
            </div>
          }

          <!-- Groups -->
          @if (form.get('visibility').value === EventVisibility.Group) {
            <div class="input-group --required">
              <label for="groupId" translate>Group</label>
              <app-dropdown [disabled]="shouldLockGroupDropdown" [options]="groups" bindValue="id" displayName="name" formControlName="groupId" id="groupId" name="groupId"></app-dropdown>
              <app-form-error [control]="form.get('groupId')" [name]="'Group' | translate"></app-form-error>
            </div>
          }

          <!--  Show Guests  -->
          <div class="input-group flex-row-start-center gap-14">
            <input class="toggle-btn" formControlName="showGuestList" id="showGuests" name="showGuests" type="checkbox" />
            <label class="reset-margin-bottom" for="showGuests" translate>Show Guests</label>
            <!--      <app-form-error [control]="form.get('showGuestList')" [name]="'Show Guests' | translate"></app-form-error>-->
          </div>

          <!--  Chargeable  -->
          <div class="align-chargeable-field">
            <div class="input-group flex-row-start gap-14">
              <input class="toggle-btn" formControlName="chargeable" id="chargeAble" name="chargeAble" type="checkbox" />
              <label class="reset-margin-bottom" for="chargeAble" translate>Chargeable</label>
              <!--      <app-form-error [control]="form.get('chargeAble')" [name]="'Chargeable' | translate"></app-form-error>-->
            </div>
            <!-- Enter Price -->
            @if (form.get('chargeable').value) {
              <div class="input-group">
                <label for="price" translate>Enter Price</label>
                <input [placeholder]="'Enter Price' | translate" appNumberInput formControlName="pricePerParticipant" id="price" name="price" type="number" />
                <!--      <app-form-error [control]="form.get('price')" [name]="'Price' | translate"></app-form-error>-->
              </div>
            }
          </div>
        </div>

        <!--  WORK SHIFT SECTION DISABLED on request from MANAGER  -->
        <!-- WORK SHIFT FORM -->
        <!--        <ng-container *ngIf="canAddWorkShifts">-->
        <!--          <div>-->
        <!--            &lt;!&ndash; Assign a task to an eventAssign a task to an event &ndash;&gt;-->
        <!--            <div class="input-group flex-row-start-center gap-14">-->
        <!--              <input class="toggle-btn" formControlName="isWorkShift" id="isWorkShift" name="isWorkShift" type="checkbox" />-->
        <!--              <label class="reset-margin-bottom" for="isWorkShift" translate>Add Work-shifts to an event</label>-->
        <!--            </div>-->

        <!--            <ng-container *ngIf="workShiftsFormArray.length > 0">-->
        <!--              <div formArrayName="eventShifts">-->
        <!--                <div *ngFor="let shift of workShiftsFormArray.controls; let i = index" [formGroupName]="i">-->
        <!--                  &lt;!&ndash; Divider and Group Number &ndash;&gt;-->
        <!--                  <ng-container *ngIf="workShiftsFormArray.controls.length > 1">-->
        <!--                    <div *ngIf="i > 0" class="divider"></div>-->
        <!--                  </ng-container>-->

        <!--                  &lt;!&ndash; Shift Image Selector &ndash;&gt;-->
        <!--                  <div class="input-group">-->
        <!--                    <label for="image" translate>Image</label>-->
        <!--                    <app-image-selector-->
        <!--                      (imageSelected)="selectedImage = $event"-->
        <!--                      [aspectRatio]="16 / 9"-->
        <!--                      [fullWidthPreview]="true"-->
        <!--                      [imageCropper]="true"-->
        <!--                      formControlName="image"-->
        <!--                      id="image"-->
        <!--                      name="image"-->
        <!--                    ></app-image-selector>-->
        <!--                    <app-form-error [control]="shift.get('image')" [name]="'Image' | translate"></app-form-error>-->
        <!--                  </div>-->

        <!--                  <div class="flex-row-between-center gap-10">-->
        <!--                    &lt;!&ndash; Shift Date &ndash;&gt;-->
        <!--                    <div class="input-group">-->
        <!--                      <label for="shiftDate">{{ 'Shift' | translate }} {{ 'Date' | translate }}</label>-->
        <!--                      <app-date-picker-input [pastDatesSelection]="false" formControlName="date" id="shiftDate" name="shiftDate" name="shiftDate"></app-date-picker-input>-->
        <!--                      <app-form-error [control]="shift.get('date')" [name]="('Shift' | translate) + ' ' + ('Date' | translate)"></app-form-error>-->
        <!--                    </div>-->

        <!--                    &lt;!&ndash;  Shift Time From  &ndash;&gt;-->
        <!--                    <div class="input-group">-->
        <!--                      <label for="startTime" translate>Start Time</label>-->
        <!--                      <app-time-picker-input class="full-width-input" formControlName="startTime" id="startTime" name="startTime"></app-time-picker-input>-->
        <!--                      <app-form-error [control]="shift.get('startTime')" [name]="'Start Time' | translate"></app-form-error>-->
        <!--                    </div>-->

        <!--                    &lt;!&ndash; Shift Time To &ndash;&gt;-->
        <!--                    <div class="input-group">-->
        <!--                      <label class="flex-row-between-center" for="endTime" translate> End Time </label>-->
        <!--                      <app-time-picker-input-->
        <!--                        [previousSelectedTime]="shift.get('startTime').value"-->
        <!--                        class="full-width-input"-->
        <!--                        formControlName="endTime"-->
        <!--                        id="endTime"-->
        <!--                        name="endTime"-->
        <!--                      ></app-time-picker-input>-->
        <!--                      <app-form-error [control]="shift.get('endTime')" [name]="'End Time' | translate"></app-form-error>-->
        <!--                    </div>-->
        <!--                  </div>-->

        <!--                  &lt;!&ndash;  Shift Title  &ndash;&gt;-->
        <!--                  <div class="input-group">-->
        <!--                    <label for="name" translate>Title</label>-->
        <!--                    <input [placeholder]="'Title' | translate" class="full-width-input" formControlName="title" id="name" name="name" type="text" />-->
        <!--                    <app-form-error [control]="shift.get('title')" [name]="'Title' | translate"></app-form-error>-->
        <!--                  </div>-->

        <!--                  &lt;!&ndash; Shift Description &ndash;&gt;-->
        <!--                  <div class="input-group">-->
        <!--                    <label for="shift-description" translate>Description</label>-->
        <!--                    <textarea [placeholder]="'Enter Description' | translate" class="full-width-input" formControlName="desc" id="shift-description" name="shift-description" rows="3"></textarea>-->
        <!--                    <app-form-error [control]="shift.get('desc')" [name]="'Description' | translate"></app-form-error>-->
        <!--                  </div>-->

        <!--                  &lt;!&ndash;  Shift Participants DropDown  &ndash;&gt;-->
        <!--                  <div class="input-group">-->
        <!--                    <label for="participants" translate>Participants</label>-->
        <!--                    <ng-select-->
        <!--                      [clearable]="true"-->
        <!--                      [closeOnSelect]="false"-->
        <!--                      [dropdownPosition]="'top'"-->
        <!--                      [hideSelected]="true"-->
        <!--                      [items]="users"-->
        <!--                      [multiple]="true"-->
        <!--                      [placeholder]="'Select Participants' | translate"-->
        <!--                      [searchable]="true"-->
        <!--                      bindLabel="fullName"-->
        <!--                      bindValue="id"-->
        <!--                      class="custom"-->
        <!--                      formControlName="shiftAssignUser"-->
        <!--                      id="participants"-->
        <!--                      name="participants"-->
        <!--                    ></ng-select>-->
        <!--                    &lt;!&ndash;              <app-dropdown [options]="teamUsers" bindValue="id" displayName="fullName" formControlName="shiftAssignUser" id="participants" name="participants"></app-dropdown>&ndash;&gt;-->
        <!--                    <app-form-error [control]="shift.get('shiftAssignUser')" [name]="'Participants' | translate"></app-form-error>-->
        <!--                  </div>-->

        <!--                  &lt;!&ndash; Shift Add Remove buttons &ndash;&gt;-->
        <!--                  <div class="flex-row-end-center gap-6 mt-12">-->
        <!--                    <ng-container *ngIf="i === workShiftsFormArray.controls.length - 1">-->
        <!--                      <button (click)="addWorkShiftRow()" [tippy]="('Add' | translate) + ' ' + ('Shift' | translate)" class="button button-simple button-icon-only">-->
        <!--                        <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="add" size="20px"></app-icon>-->
        <!--                      </button>-->
        <!--                    </ng-container>-->

        <!--                    <ng-container *ngIf="workShiftsFormArray.length > 1">-->
        <!--                      <button (click)="removeWorkShiftRow(i)" [tippy]="('Remove' | translate) + ' ' + ('Shift' | translate)" class="button button-simple button-icon-only">-->
        <!--                        <app-icon [cssStyle]="{ marginTop: '-2px' }" iconName="trash-bin" size="20px"></app-icon>-->
        <!--                      </button>-->
        <!--                    </ng-container>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--            </ng-container>-->
        <!--          </div>-->
        <!--        </ng-container>-->

        <div>
          <!-- Assign a task to an eventAssign a task to an event -->
          <div class="input-group flex-row-start-center gap-14">
            <input class="toggle-btn" formControlName="isTask" id="assignTaskToEvent" name="assignTaskToEvent" type="checkbox" />
            <label class="reset-margin-bottom" for="assignTaskToEvent" translate>Assign a task to an event</label>
          </div>
          @if (form.get('isTask').value) {
            <div class="showAssignTaskForm" formGroupName="task">
              <!-- Title -->
              <div class="input-group --required">
                <label for="title" translate>Title</label>
                <input [placeholder]="'Title' | translate" class="full-width-input" formControlName="title" id="title" name="title" type="text" />
                <app-form-error [control]="form.get('task.title')" [name]="'Title' | translate"></app-form-error>
              </div>
              <!-- Description -->
              <div class="input-group --required">
                <label for="description" translate>Task Description</label>
                <textarea [placeholder]="'Task Description' | translate" class="full-width-input" formControlName="description" id="taskDescription" name="taskDescription" rows="3"></textarea>
                <app-form-error [control]="form.get('task.description')" [name]="'Task Description' | translate"></app-form-error>
              </div>
              <!-- Task Types -->
              <div class="input-group --required">
                <label for="taskType" translate>Task Types</label>
                <app-dropdown [options]="taskTypes" bindValue="value" displayName="key" formControlName="type" id="taskType" name="taskType"></app-dropdown>
                <app-form-error [control]="form.get('task.type')" [name]="'Task Type' | translate"></app-form-error>
              </div>
              <!-- Participants -->
              @if (form.get('task.type').value === EventTaskType.Individual) {
                <div class="input-group --required">
                  <label for="taskParticipants" translate>Participants</label>
                  <ng-select
                    [closeOnSelect]="true"
                    [items]="users"
                    [multiple]="true"
                    [placeholder]="'Select Options' | translate"
                    [searchable]="true"
                    bindLabel="fullName"
                    bindValue="id"
                    class="custom"
                    dropdownPosition="top"
                    formControlName="userSelect"
                    id="taskParticipants"
                    name="taskParticipants"
                  >
                    <ng-template ng-footer-tmp>
                      <button (click)="selectAllParticipants(true)" class="button button-small button-outline-primary" translate>Select all</button>
                      <button (click)="unSelectAll(true)" class="button button-small button-simple" translate>Unselect all</button>
                    </ng-template>
                  </ng-select>
                  <app-form-error [control]="form.get('userSelect')" [name]="'Participants' | translate"></app-form-error>
                </div>
              }
              <!-- Groups -->
              @if (form.get('task.type').value === EventTaskType.Group) {
                <div class="input-group --required">
                  <label for="taskGroupId" translate>Group</label>
                  <app-dropdown [dropdownPosition]="'top'" [options]="groups" bindValue="id" displayName="name" formControlName="groupId" id="taskGroupId" name="taskGroupId"></app-dropdown>
                  <app-form-error [control]="form.get('groupId')" [name]="'Group' | translate"></app-form-error>
                </div>
              }
              <!-- Date Picker  -->
              <div class="input-group --required">
                <label for="endDate" translate>End Date</label>
                <app-date-picker-input [pastDatesSelection]="false" formControlName="date" id="endDate" name="endDate"></app-date-picker-input>
                <app-form-error [control]="form.get('task.date')" [name]="'End Date' | translate"></app-form-error>
              </div>
            </div>
          }
        </div>
      </div>
    </form>
  </div>

  <footer>
    <div class="dialog__footer">
      @if (!isMobileView()) {
        <div class="dialog__footer__buttons">
          <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="(eventId ? 'Update' : 'Save') | translate"></app-button>
        </div>
      }
    </div>
    @if (isMobileView()) {
      <div class="mobile-button mb-34 mx-16">
        <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="(eventId ? 'Update' : 'Save') | translate" cssClass="button-primary button-full"></app-button>
      </div>
    }
  </footer>
</div>
